import { defineStore } from 'pinia'
import { deleteStoreState, updateStoreState } from '../helpers/stateUtils'

export const useAlertStore = defineStore({
  id: 'alert',
  state: () => ({
    alerts: [],
  }),
  getters: {
    findAll: (state) => state.alerts,
  },
  actions: {
    clearAlert (id) {
      deleteStoreState(this.alerts, id)
    },

    setAlert (payload) {
      const {
        message,
        type,
        timeout,
      } = payload

      // generate a random id so we can identify this alert
      const id = Math.random().toString(18).replace(/[^\w]/gi, '').substring(0, 7)

      // add the new alert
      updateStoreState(this.alerts, { id, message, type, timeout })

      // if there's a timeout then remove the alert after a period of time
      if (timeout) {
        setTimeout(() => {
          deleteStoreState(this.alerts, id)
        }, timeout)
      }
    },

    setAlertSuccess (payload) {
      const {
        message,
        timeout = 6000,
      } = payload

      return this.setAlert({
        message,
        type: 'success',
        timeout,
      })
    },

    setAlertError (payload) {
      const {
        message,
        timeout = null,
      } = payload

      return this.setAlert({
        message,
        type: 'error',
        timeout,
      })
    },
  },
})
